const KEY = 'SNACKBAR';

/**
 * Function to show snackbar globally.
 * @param {Array} message Message to show in the snackbar.
 */
export function showSnackbar(message) {
  return {
    type: `${KEY}_SHOW`,
    payload: message
  };
}

/**
 * Function to hide snackbar globally.
 * @param {Integer} id Message id to hide.
 */
export function dismissSnackbar(id) {
  return {
    type: `${KEY}_DISMISS`,
    payload: id
  };
}

/**
 * Function to hide snackbar globally.
 */
export function dismissLast() {
  return {
    type: `${KEY}_DISMISS_LAST`
  };
}

/**
 * Function to clear snackbar.
 */
export function clearSnackbar() {
  return {
    type: `${KEY}_CLEAR`
  };
}
